import get from 'lodash/get';
import debounce from 'lodash/debounce';
import { containerConnect } from '@configuratorware/configurator-frontendgui/Framework/ComponentContainer';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import createSelector from '@configuratorware/configurator-frontendgui/Utils/Function/createSelector';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import {
  getSelectedDesignProductionMethod,
  getVectorizedImageColor,
  isColoringDisabled,
  getDesignDataForSelectedDesignArea,
} from '@configuratorware/configurator-frontendgui/App/Reducers/DesignArea/Selectors';

import { addCustomFont } from '@configuratorware/configurator-frontendgui/App/Reducers/Fonts/Actions';
import { getDefaultFont } from '@configuratorware/configurator-frontendgui/App/Reducers/Fonts/Selectors';
import { setVisible } from '@configuratorware/configurator-frontendgui/App/Reducers/UI/Actions';
import { FontFaceRepository } from '@configuratorware/configurator-frontendgui/App/Modules/Designer/Utils/FontFaceRepository';
import FontToolbox from '../Components/FontToolbox/DesignerSelectionToolbox';
import { setDesignerMobileProductListOpen, setDesignerMobileModalContent } from '../../../Reducers/CustomDesignReducer/Actions';

const getFonts = createSelector(
  (state) => state.fonts,
  (fonts) => fonts.map((font) => ({
    ...font,
    value: font.family,
  })),
);

const loadFonts = (dispatch) => (textItem) => {
  if (!textItem || !textItem.content) {
    return;
  }
  const toggleLoader = (show) => dispatch(setVisible('globalLoader', show));
  const showLoaderTimeout = window.setTimeout(() => toggleLoader(true), 300);
  FontFaceRepository.collectFromHTML(textItem.content)
    .catch((e) => {
      // eslint-disable-next-line no-console
      console.error('Error while loading fonts.', e);
    })
    .finally(() => {
      textItem.build({ triggerChange: true });
      clearTimeout(showLoaderTimeout);
      toggleLoader(false);
    });
};

const mapStateToProps = (state) => ({
  Component: FontToolbox,
  fonts: getFonts(state),
  colorDisabled: isColoringDisabled(state),
  isActiveBulkName: get(getSelectedDesignProductionMethod(state), 'allowBulkNames'),
  isPortraitMode: state.device.screen.orientation === 'portrait',
  defaultFont: getDefaultFont(state),
  initialColor: getVectorizedImageColor(state),
  modalContentOptions: state.customDesignerData.designerMobileModalContentOptions,
  currentModalContentOption: state.customDesignerData.designerMobileModalContent,
  designDataForSelectedDesignArea: getDesignDataForSelectedDesignArea(state),
});

const mapDispatchToProps = (dispatch) => ({
  updateVisualization: (canvas) => {
    canvas.selectedObject.x += 1;
    canvas.selectedObject.x -= 1;
  },
  openImageEditDialog: (identifier, canvas, placeholderImageUpdate = false) => Services.designer.openImageEditDialog(identifier, canvas, { placeholderImageUpdate }),
  getTextContent: ({ isBulkName }) => Services.designer.createColorizedTextContent(
    t(isBulkName ? 'textControlbox.bulknames' : 'addVisualElement.initialText'),
    1,
    {
      withPlaceholder: !isBulkName,
    },
  ),
  replaceTextEditDialogCanvas: (area) => { Services.designData.restoreCanvasDataForCurrentDesignArea(area); },
  addCustomFont: (customFont) => {
    dispatch(addCustomFont(customFont));
  },
  loadFonts: debounce(loadFonts(dispatch), 300),
  setModalContentOption: (value) => {
    dispatch(setDesignerMobileModalContent(value));
  },
  closeMobilePickerMenu: () => { dispatch(setDesignerMobileProductListOpen(false)); },
  closeDesignArea: () => Services.designData.clearDesignAreaSelection(),

});

export default containerConnect(mapStateToProps, mapDispatchToProps);
